import React from 'react'
import useGetLiveModelCR from '../hooks/useGetLiveModelCR';
import ChartCard from './ChartCard';
import useGetTrainModelCR from '../hooks/useGetTrainModelCR';

const CRChart = ({ id, start, end, units, currTab, list, modelId, modelStatus }) => {

    const { data, loading } = useGetLiveModelCR(id, start, end, units, currTab, list);
    const { data: trainData, loading: trainLoading } = useGetTrainModelCR(id, start, end, units, currTab, list, modelId);


    let graphData = [];

    if (data && data.length > 0 && !loading) {
        graphData = [...data, ...graphData]
    }
    if (modelStatus === "OBSERVATION" && trainData && trainData.length > 0 && !trainLoading) {

        graphData = [...trainData, ...graphData]
    }

    return (
        <ChartCard
            sensor={id}
            title={"Corrosion Rate"}
            loading={loading || trainLoading}
            graphdata={graphData}
            units={units}
            fixedYRangeVariables={["Predicted Corrosion Rate", "Measured Corrosion Rate", "Trained Model Predicted Corrosion Rate"]}
        />
    )
}

export default CRChart